// Lazy loader for the Razorpay Checkout script.
// Returns a promise that resolves once window.Razorpay is available.
let _razorpayPromise = null;

export function loadRazorpay() {
  if (typeof window !== "undefined" && window.Razorpay) {
    return Promise.resolve(window.Razorpay);
  }
  if (_razorpayPromise) return _razorpayPromise;
  _razorpayPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(window.Razorpay);
    s.onerror = () => {
      _razorpayPromise = null;
      reject(new Error("Failed to load Razorpay Checkout"));
    };
    document.body.appendChild(s);
  });
  return _razorpayPromise;
}
